import { FormGroup as MuiFormGroup, FormGroupProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export type { FormGroupProps };

export const FormGroup: React.ComponentType<FormGroupProps> = styled(MuiFormGroup)<FormGroupProps>(
  () => ({}),
);
